import { getOwner, runWithOwner } from "solid-js";

import Telemetry from "@repo/telemetry";
import FullName from "@repo/utils/FullName";
import UString from "@repo/utils/UString";

import { scriptSrc } from "~/analytics/utils";
import appSettings from "~/appSettings";
import { useUser } from "~/state/features/user";
import Marketing from "~/utils/Marketing";

import { Registration } from "../../client";

declare global {
  interface Window {
    // googleAnalytics (gtag.js) client uses dataLayer and is not renameable
    gtmDataLayer: object[];
  }
}

const id = appSettings.marketing.gtmId;

export default (): Registration.Conversion => {
  if (!id) return;
  if (import.meta.env.APP_ENV !== "production") return;

  // @ts-expect-error
  // prettier-ignore
  // eslint-disable-next-line
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=scriptSrc('https://www.googletagmanager.com/gtm.js?id='+i+dl);f.parentNode.insertBefore(j,f);})(window,document,'script','gtmDataLayer',id);

  window.gtmDataLayer ??= [];

  return {
    identify() {
      // Do nothing
    },
    track(name, properties) {
      const [user] = useUser();

      const tier = Marketing.useTier(properties);
      const owner = getOwner()!;

      const commonProperties = {
        event: name,
        user_id: user.id(),
        email: user.pii()?.email,
        name: FullName.format(user.pii()?.name),

        ...(() => {
          if (name === "Make Credit Line Payment") {
            const price = runWithOwner(owner, () =>
              Marketing.useTransactionPrice(properties)
            );

            return {
              transactionId: properties.accountId,
              transaction_id: properties.accountId, // For AppsLovin
              itemName: tier,
              itemId: tier,
              price,
              quantity: 1,
            };
          }
        })(),

        ...properties,
      };

      window.gtmDataLayer.push(commonProperties);

      if (name === "Credit Account Open") {
        if (typeof properties.tier !== "string")
          Telemetry.captureError(
            new Error(
              'Expected "Credit Account Open" conversion event to have a string "tier" property'
            )
          );
        else
          window.gtmDataLayer.push({
            ...commonProperties,
            event: `CAO - ${UString.capitalize(properties.tier)}`,
          });
      }
    },
  };
};
